import { WPMenu } from 'types/menus';
import { useApiRequest } from './useApiRequest';

type UseMenu = {
  readonly slug?: string;
  readonly skip?: boolean;
};

const endpoint = 'menus';

export const useMenu = (options?: UseMenu) => {
  const { slug, ...restOptions } = options || {};
  return useApiRequest<WPMenu>({
    ...restOptions,
    endpoint: slug ? `${endpoint}/${slug}` : endpoint,
    customUrl: process.env.REACT_APP_WP_API_MENUS,
    cacheKey: `menus:${slug}`,
    embed: false,
    skipLang: true,
  });
};
